import React, { Component } from "react";
import OrgChart from "@balkangraph/orgchart.js";

export default class orgChart extends Component {
  constructor(props) {
    super(props);
    this.divRef = React.createRef();
  }

  shouldComponentUpdate() {
    return false;
  }

  componentDidMount() {
    console.log(`FreeTrial : ${OrgChart.isTrial()}`);
    let templates = [
      { name: "t0", color: "#23272E" },
      { name: "t100", color: "#2E86C1" },
      { name: "t300", color: "#1D8348" },
      { name: "t1000", color: "#9A7D0A" },
      { name: "t3000", color: "#D4AC0D" },
      { name: "t6000", color: "#F8C471" },
      { name: "t10000", color: "#943126" },
      { name: "t30000", color: "#CB4335" },
      { name: "t60000", color: "#F1948A" },
      { name: "t90000", color: "#884EA0" },
      { name: "t120000", color: "#AF7AC5" },
    ];

    if (this.props.type === "sponsor") {
      templates.forEach((t) => {
        OrgChart.templates[t.name] = Object.assign({}, OrgChart.templates.ana);
        OrgChart.templates[t.name].size = [200, 100];
        OrgChart.templates[t.name].link =
          '<path stroke="#ccc" stroke-width="3px" fill="none" data-l-id="[{id}][{child-id}]" d="M{xa},{ya} C{xb},{yb} {xc},{yc} {xd},{yd}" />';
        OrgChart.templates[
          t.name
        ].node = `<rect width="200" height="100" rx="15" style="fill:${t.color};stroke-width:3;stroke:#fff"></rect>`;
        OrgChart.templates[t.name].name =
          '<text style="font-size: 20px;" fill="#fff" x="100" y="35" text-anchor="middle">{val}</text> ';
        OrgChart.templates[t.name].vaildDeposit =
          '<text style="font-size: 20px;" fill="#fff" x="100" y="60" text-anchor="middle">( {val} )</text>';
        OrgChart.templates[t.name].left =
          '<text style="font-size: 16px;" fill="#fff" x="95" y="82" text-anchor="end">{val}</text>';
        OrgChart.templates[t.name].right =
          '<text style="font-size: 16px;" fill="#fff" x="105" y="82" text-anchor="start">{val}</text>';
        OrgChart.templates[t.name].split =
          '<text style="font-size: 20px;" x="100" y="81" fill="#ddd" text-anchor="middle">{val}</text>';
      });
    } else {
      templates.forEach((t) => {
        OrgChart.templates[t.name] = Object.assign({}, OrgChart.templates.ana);
        OrgChart.templates[t.name].size = [200, 100];
        OrgChart.templates[t.name].direction =
          '<text style="font-size: 20px;" x="100" y="25" fill="#ddd" text-anchor="middle">{val}</text>';
        OrgChart.templates[t.name].link =
          '<path stroke="#ccc" stroke-width="3px" fill="none" data-l-id="[{id}][{child-id}]" d="M{xa},{ya} C{xb},{yb} {xc},{yc} {xd},{yd}" />';
        OrgChart.templates[
          t.name
        ].node = `<rect width="200" height="100" rx="15" style="fill:${t.color};stroke-width:3;stroke:#fff"></rect>`;
        OrgChart.templates[t.name].name =
          '<text style="font-size: 20px;" fill="#fff" x="100" y="50" text-anchor="middle">{val}</text> ';
        OrgChart.templates[t.name].deposit =
          '<text style="font-size: 20px;" fill="#fff" x="100" y="78" text-anchor="middle">( {val} )</text>';
        OrgChart.templates[t.name].left =
          '<text style="font-size: 16px;" fill="#fff" x="95" y="82" text-anchor="end">{val}</text>';
        OrgChart.templates[t.name].right =
          '<text style="font-size: 16px;" fill="#fff" x="105" y="82" text-anchor="start">{val}</text>';
        OrgChart.templates[t.name].split =
          '<text style="font-size: 20px;" x="100" y="81" fill="#ddd" text-anchor="middle">{val}</text>';
      });
    }

    // OrgChart.templates.myTemplate.size = [150, 100];

    this.chart = new OrgChart(this.divRef.current, {
      // layout: OrgChart.mixed,
      nodes: this.props.nodes,
      sticky: false,
      miniMap: false,
      align: OrgChart.align.center,
      nodeBinding: {
        name: "name",
        deposit: "deposit",
        vaildDeposit: "vaildDeposit",
        left: "leftFix", //자신의 몸값이 0이면 왼쪽도 0으로 표시하기 위해
        right: "rightFix", //자신의 몸값이 0이면 오른쪽도 0으로 표시하기 위해
        split: "split",
        direction: "direction",
      },
      mode: "dark",
      nodeMouseClick: OrgChart.action.pan,
      searchDisplayField: "name",
      scaleInitial: 0.5,
      zoom: {
        speed: 120,
        smooth: 10,
      },
      template: "t0",
      toolbar: {
        layout: false,
        zoom: true,
        fit: true,
        expandAll: false,
        fullScreen: false,
      },
      tags: {
        t0: {
          template: "t0",
        },
        t100: {
          template: "t100",
        },
        t300: {
          template: "t300",
        },
        t1000: {
          template: "t1000",
        },
        t3000: {
          template: "t3000",
        },
        t6000: {
          template: "t6000",
        },
        t10000: {
          template: "t10000",
        },
        t30000: {
          template: "t30000",
        },
        t60000: {
          template: "t60000",
        },
        t90000: {
          template: "t90000",
        },
        t120000: {
          template: "t120000",
        },
      },
    });
  }

  render() {
    return (
      <div
        id="tree"
        ref={this.divRef}
        style={{ width: "100%", height: "900px", backgroundColor: "#23272E" }}
      />
    );
  }
}
